import {
  Landmark, Building2, Scale, Wrench, Croissant, Beer, Scissors, Coffee, Car,
  Stethoscope, ShoppingBasket, Smile, Cpu, Sandwich, Fuel, Armchair, Dumbbell,
  Hammer, Cross, BedDouble, ShieldCheck, Gem, Shirt, BookOpen, Wine, PawPrint,
  Pill, KeyRound, Utensils, ShoppingBag, GraduationCap, ShoppingCart, Clapperboard,
  Package, Truck, SquareParking, Weight, Caravan, Ticket,
  Dices, Cannabis, Puzzle, Tent, Tag, HeartHandshake,
  Trophy, Flag, Swords, Target, Medal, CircleDot, Gamepad2, Waves, Joystick,
  Baby, Backpack, Sparkles,
  HeartPulse, Users,
  MapPin,
} from "lucide-react";

const ICONS = {
  Landmark, Building2, Scale, Wrench, Croissant, Beer, Scissors, Coffee, Car,
  Stethoscope, ShoppingBasket, Smile, Cpu, Sandwich, Fuel, Armchair, Dumbbell,
  Hammer, Cross, BedDouble, ShieldCheck, Gem, Shirt, BookOpen, Wine, PawPrint,
  Pill, KeyRound, Utensils, ShoppingBag, GraduationCap, ShoppingCart, Clapperboard,
  Package, Truck, SquareParking, Weight, Caravan, Ticket,
  Dices, Cannabis, Puzzle, Tent, Tag, HeartHandshake,
  Trophy, Flag, Swords, Target, Medal, CircleDot, Gamepad2, Waves, Joystick,
  Baby, Backpack, Sparkles,
  HeartPulse, Users,
  MapPin,
};

export function getIcon(name) {
  return ICONS[name] || MapPin;
}
